import { IEntity } from './entity';

export type IMarket = IEntity & {
  id: string;
  title?: string;
  countries?: string[] | IEntity[];
  languages?: string[] | IEntity[];
  defaultLanguage?: string | IEntity;
  isActive?: boolean;
  isDefault?: boolean;
  isHidden?: boolean;
};
